/**
 * Рендерер результата боя
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Рендерит результат боя в элемент #battle-result
 * 
 * @param {object} params - Параметры рендеринга
 * @param {object} params.battle - Объект боя
 * @param {object} params.summary - Сводка боя
 * @param {object} params.evolutionResults - Результаты эволюции
 * @param {object} params.battleState - Состояние боя (panels, winner)
 * @param {function} params.escapeHtml - Функция экранирования HTML
 * @param {function} params.formatBattleLogEntry - Функция форматирования записи лога
 * @param {function} params.getBattleWinner - Функция получения победителя
 * @param {function} params.calculateBattleStats - Функция расчета статистики
 * @param {function} params.formatBattleStats - Функция форматирования статистики
 * @param {function} params.renderBattleStats - Функция рендеринга статистики
 */
export function renderBattleResult({
  battle,
  summary = {},
  evolutionResults = [],
  battleState,
  escapeHtml,
  formatBattleLogEntry,
  getBattleWinner,
  calculateBattleStats,
  formatBattleStats,
  renderBattleStats,
}) {
  const resultElement = document.getElementById("battle-result");
  if (!resultElement) return;
  
  if (!battle) {
    resultElement.style.display = "none";
    return;
  }
  
  // Определяем победителя
  let winner = summary.winner || getBattleWinner?.(battle) || "—";
  const battleWinner = battleState?.winner;
  if (battleWinner) {
    if (battleWinner.team === null) {
      winner = "Ничья";
    } else {
      winner = battleWinner.owner || battleWinner.name || `Команда ${battleWinner.team}`;
    }
  }
  
  // Подсчитываем метрики
  const stackResets = summary.stackResets ?? 
    (battle.log || []).filter((entry) => entry.event === "stack_reset").length;
  const evolutions = summary.evolutions ?? 
    (battle.log || []).filter((entry) => entry.event === "evolution").length;
  const fragmentsGranted = summary.fragmentsGranted ?? evolutionResults.length;
  
  // Создаём карты для поиска имён бойцов
  const panelsMap = new Map(
    (battleState?.panels || []).map((panel) => [String(panel.id), panel])
  );
  const combatantsMap = new Map(
    (battle.combatants || []).map((combatant) => [
      String(
        combatant.id ??
        combatant.combatantId ??
        combatant.combatant_id ??
        combatant.slotId ??
        combatant.slot_id ??
        combatant.panelId ??
        combatant.panel_id ??
        combatant.sourceId ??
        combatant.source_id
      ),
      combatant,
    ])
  );
  
  // Функция для получения имени бойца
  const getCombatantName = (id) => {
    if (id == null) return null;
    const idStr = String(id);
    
    if (panelsMap.has(idStr)) {
      const panel = panelsMap.get(idStr);
      return panel.owner ? `${panel.owner} (${panel.name})` : panel.name;
    }
    
    if (combatantsMap.has(idStr)) {
      const combatant = combatantsMap.get(idStr);
      return combatant.name || combatant.owner || combatant.title || `Боец #${idStr}`;
    }
    
    return null;
  };
  
  // Форматируем лог боя
  const battleLogHtml = (battle.log || [])
    .map((entry) => `<div class="battle-log-entry">${formatBattleLogEntry(entry, getCombatantName)}</div>`)
    .join("") || '<div class="battle-log-entry">Лог пуст</div>';
  
  // Форматируем результаты эволюции
  const evolutionResultsHtml = evolutionResults
    .map(
      (result) =>
        `<div>Фрагмент: ${escapeHtml(result.fragment || "-")}, собрано: ${result.fragmentsCollected}</div>`
    )
    .join("");
  
  // Вычисляем статистику боя
  let statsHtml = "";
  try {
    if (calculateBattleStats && formatBattleStats && renderBattleStats) {
      const battleStats = calculateBattleStats(battle, battleState?.panels || []);
      const formattedStats = formatBattleStats(battleStats, battleState?.panels || []);
      statsHtml = renderBattleStats(formattedStats, escapeHtml);
    }
  } catch (statsError) {
    console.warn("Error calculating battle stats:", statsError);
  }
  
  // Рендерим результат
  // Примечание: информация о победителе показывается в баннере (battle-winner-banner),
  // поэтому не дублируем её здесь
  resultElement.innerHTML = `
    <h4 style="margin-top: 0;">Результат боя</h4>
    <div style="font-size: 14px; margin-bottom: 8px;">
      <div>Статус: <strong>${escapeHtml(battle.status || "completed")}</strong>${battle.isPublic ? " • 🌐 Публичный" : ""}</div>
      <div>Раундов: <strong>${battle.round}</strong></div>
      <div>Перезагрузок The Stack: <strong>${stackResets}</strong></div>
      <div>Эволюций: <strong>${evolutions}</strong></div>
      <div>Выдано фрагментов: <strong>${fragmentsGranted}</strong></div>
    </div>
    ${statsHtml ? `<div style="margin-bottom: 12px;">${statsHtml}</div>` : ""}
    ${evolutionResultsHtml ? `<div style="font-size: 12px; color: var(--tg-theme-hint-color); margin-bottom: 8px;">${evolutionResultsHtml}</div>` : ""}
    <div class="battle-log">${battleLogHtml}</div>
  `;
  
  resultElement.style.display = "block";
}










